/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Admin BFF API
 * Authentication and admin gateway for the AvilaRoffe platform.
 * OpenAPI spec version: 1.0
 */
import type {
  BodyBody,
  DeleteAgentsId401,
  DeleteAgentsId404,
  DeleteAgentsId502,
  DeleteAgentsIdOverrides401,
  DeleteAgentsIdOverrides404,
  DeleteAgentsIdOverrides502,
  GetAgents200,
  GetAgents401,
  GetAgents502,
  GetAgentsId200,
  GetAgentsId401,
  GetAgentsId404,
  GetAgentsId502,
  GetAgentsIdOverrides200,
  GetAgentsIdOverrides401,
  GetAgentsIdOverrides404,
  GetAgentsIdOverrides502,
  GetAgentsIdResolve200,
  GetAgentsIdResolve401,
  GetAgentsIdResolve404,
  GetAgentsIdResolve502,
  GetAgentsIdTools200,
  GetAgentsIdTools401,
  GetAgentsIdTools404,
  GetAgentsIdTools502,
  GetAgentsParams,
  PatchAgentsId200,
  PatchAgentsId400,
  PatchAgentsId401,
  PatchAgentsId404,
  PatchAgentsId502,
  PostAgents201,
  PostAgents400,
  PostAgents401,
  PostAgents502,
  PostAgentsBody,
  PutAgentsIdOverrides200,
  PutAgentsIdOverrides400,
  PutAgentsIdOverrides401,
  PutAgentsIdOverrides502,
  PutAgentsIdOverridesBody
} from '../adminBFFAPI.schemas';

import { adminBffFetch } from '../../mutator';

/**
 * Proxied to agent-manager. Supports filtering by tenantSlug, appSlug, status.
 * @summary List agents
 */
export type getAgentsResponse200 = {
  data: GetAgents200
  status: 200
}

export type getAgentsResponse401 = {
  data: GetAgents401
  status: 401
}

export type getAgentsResponse502 = {
  data: GetAgents502
  status: 502
}
    
export type getAgentsResponseSuccess = (getAgentsResponse200) & {
  headers: Headers;
};
export type getAgentsResponseError = (getAgentsResponse401 | getAgentsResponse502) & {
  headers: Headers;
};

export type getAgentsResponse = (getAgentsResponseSuccess | getAgentsResponseError)

export const getGetAgentsUrl = (params?: GetAgentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/agents?${stringifiedParams}` : `/agents`
}

export const getAgents = async (params?: GetAgentsParams, options?: RequestInit): Promise<getAgentsResponse> => {
  
  return adminBffFetch<getAgentsResponse>(getGetAgentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to agent-manager.
 * @summary Create an agent
 */
export type postAgentsResponse201 = {
  data: PostAgents201
  status: 201
}

export type postAgentsResponse400 = {
  data: PostAgents400
  status: 400
}

export type postAgentsResponse401 = {
  data: PostAgents401
  status: 401
}

export type postAgentsResponse502 = {
  data: PostAgents502
  status: 502
}
    
export type postAgentsResponseSuccess = (postAgentsResponse201) & {
  headers: Headers;
};
export type postAgentsResponseError = (postAgentsResponse400 | postAgentsResponse401 | postAgentsResponse502) & {
  headers: Headers;
};

export type postAgentsResponse = (postAgentsResponseSuccess | postAgentsResponseError)

export const getPostAgentsUrl = () => {


  

  return `/agents`
}

export const postAgents = async (postAgentsBody: PostAgentsBody, options?: RequestInit): Promise<postAgentsResponse> => {
  
  return adminBffFetch<postAgentsResponse>(getPostAgentsUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      postAgentsBody,)
  }
);}


/**
 * Proxied to agent-manager.
 * @summary Get an agent by ID or name
 */
export type getAgentsIdResponse200 = {
  data: GetAgentsId200
  status: 200
}

export type getAgentsIdResponse401 = {
  data: GetAgentsId401
  status: 401
}

export type getAgentsIdResponse404 = {
  data: GetAgentsId404
  status: 404
}

export type getAgentsIdResponse502 = {
  data: GetAgentsId502
  status: 502
}
    
export type getAgentsIdResponseSuccess = (getAgentsIdResponse200) & {
  headers: Headers;
};
export type getAgentsIdResponseError = (getAgentsIdResponse401 | getAgentsIdResponse404 | getAgentsIdResponse502) & {
  headers: Headers;
};

export type getAgentsIdResponse = (getAgentsIdResponseSuccess | getAgentsIdResponseError)

export const getGetAgentsIdUrl = (id: string,) => {


  

  return `/agents/${id}`
}

export const getAgentsId = async (id: string, options?: RequestInit): Promise<getAgentsIdResponse> => {
  
  return adminBffFetch<getAgentsIdResponse>(getGetAgentsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to agent-manager.
 * @summary Delete an agent
 */
export type deleteAgentsIdResponse204 = {
  data: void
  status: 204
}

export type deleteAgentsIdResponse401 = {
  data: DeleteAgentsId401
  status: 401
}

export type deleteAgentsIdResponse404 = {
  data: DeleteAgentsId404
  status: 404
}

export type deleteAgentsIdResponse502 = {
  data: DeleteAgentsId502
  status: 502
}
    
export type deleteAgentsIdResponseSuccess = (deleteAgentsIdResponse204) & {
  headers: Headers;
};
export type deleteAgentsIdResponseError = (deleteAgentsIdResponse401 | deleteAgentsIdResponse404 | deleteAgentsIdResponse502) & {
  headers: Headers;
};

export type deleteAgentsIdResponse = (deleteAgentsIdResponseSuccess | deleteAgentsIdResponseError)

export const getDeleteAgentsIdUrl = (id: string,) => {


  

  return `/agents/${id}`
}

export const deleteAgentsId = async (id: string, options?: RequestInit): Promise<deleteAgentsIdResponse> => {
  
  return adminBffFetch<deleteAgentsIdResponse>(getDeleteAgentsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * Proxied to agent-manager.
 * @summary Update an agent
 */
export type patchAgentsIdResponse200 = {
  data: PatchAgentsId200
  status: 200
}

export type patchAgentsIdResponse400 = {
  data: PatchAgentsId400
  status: 400
}

export type patchAgentsIdResponse401 = {
  data: PatchAgentsId401
  status: 401
}

export type patchAgentsIdResponse404 = {
  data: PatchAgentsId404
  status: 404
}

export type patchAgentsIdResponse502 = {
  data: PatchAgentsId502
  status: 502
}
    
export type patchAgentsIdResponseSuccess = (patchAgentsIdResponse200) & {
  headers: Headers;
};
export type patchAgentsIdResponseError = (patchAgentsIdResponse400 | patchAgentsIdResponse401 | patchAgentsIdResponse404 | patchAgentsIdResponse502) & {
  headers: Headers;
};

export type patchAgentsIdResponse = (patchAgentsIdResponseSuccess | patchAgentsIdResponseError)

export const getPatchAgentsIdUrl = (id: string,) => {


  

  return `/agents/${id}`
}

export const patchAgentsId = async (id: string,
    bodyBody: BodyBody, options?: RequestInit): Promise<patchAgentsIdResponse> => {
  
  return adminBffFetch<patchAgentsIdResponse>(getPatchAgentsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bodyBody,)
  }
);}


/**
 * Proxied to agent-manager. Returns tenant-specific config overrides.
 * @summary Get tenant overrides for an agent
 */
export type getAgentsIdOverridesResponse200 = {
  data: GetAgentsIdOverrides200
  status: 200
}

export type getAgentsIdOverridesResponse401 = {
  data: GetAgentsIdOverrides401
  status: 401
}

export type getAgentsIdOverridesResponse404 = {
  data: GetAgentsIdOverrides404
  status: 404
}

export type getAgentsIdOverridesResponse502 = {
  data: GetAgentsIdOverrides502
  status: 502
}
    
export type getAgentsIdOverridesResponseSuccess = (getAgentsIdOverridesResponse200) & {
  headers: Headers;
};
export type getAgentsIdOverridesResponseError = (getAgentsIdOverridesResponse401 | getAgentsIdOverridesResponse404 | getAgentsIdOverridesResponse502) & {
  headers: Headers;
};

export type getAgentsIdOverridesResponse = (getAgentsIdOverridesResponseSuccess | getAgentsIdOverridesResponseError)

export const getGetAgentsIdOverridesUrl = (id: string,) => {


  

  return `/agents/${id}/overrides`
}

export const getAgentsIdOverrides = async (id: string, options?: RequestInit): Promise<getAgentsIdOverridesResponse> => {
  
  return adminBffFetch<getAgentsIdOverridesResponse>(getGetAgentsIdOverridesUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to agent-manager. Replace-all semantics.
 * @summary Set tenant overrides for an agent
 */
export type putAgentsIdOverridesResponse200 = {
  data: PutAgentsIdOverrides200
  status: 200
}

export type putAgentsIdOverridesResponse400 = {
  data: PutAgentsIdOverrides400
  status: 400
}

export type putAgentsIdOverridesResponse401 = {
  data: PutAgentsIdOverrides401
  status: 401
}

export type putAgentsIdOverridesResponse502 = {
  data: PutAgentsIdOverrides502
  status: 502
}
    
export type putAgentsIdOverridesResponseSuccess = (putAgentsIdOverridesResponse200) & {
  headers: Headers;
};
export type putAgentsIdOverridesResponseError = (putAgentsIdOverridesResponse400 | putAgentsIdOverridesResponse401 | putAgentsIdOverridesResponse502) & {
  headers: Headers;
};

export type putAgentsIdOverridesResponse = (putAgentsIdOverridesResponseSuccess | putAgentsIdOverridesResponseError)

export const getPutAgentsIdOverridesUrl = (id: string,) => {


  

  return `/agents/${id}/overrides`
}

export const putAgentsIdOverrides = async (id: string,
    putAgentsIdOverridesBody: PutAgentsIdOverridesBody, options?: RequestInit): Promise<putAgentsIdOverridesResponse> => {
  
  return adminBffFetch<putAgentsIdOverridesResponse>(getPutAgentsIdOverridesUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      putAgentsIdOverridesBody,)
  }
);}


/**
 * Proxied to agent-manager.
 * @summary Remove all tenant overrides for an agent
 */
export type deleteAgentsIdOverridesResponse204 = {
  data: void
  status: 204
}

export type deleteAgentsIdOverridesResponse401 = {
  data: DeleteAgentsIdOverrides401
  status: 401
}

export type deleteAgentsIdOverridesResponse404 = {
  data: DeleteAgentsIdOverrides404
  status: 404
}

export type deleteAgentsIdOverridesResponse502 = {
  data: DeleteAgentsIdOverrides502
  status: 502
}
    
export type deleteAgentsIdOverridesResponseSuccess = (deleteAgentsIdOverridesResponse204) & {
  headers: Headers;
};
export type deleteAgentsIdOverridesResponseError = (deleteAgentsIdOverridesResponse401 | deleteAgentsIdOverridesResponse404 | deleteAgentsIdOverridesResponse502) & {
  headers: Headers;
};

export type deleteAgentsIdOverridesResponse = (deleteAgentsIdOverridesResponseSuccess | deleteAgentsIdOverridesResponseError)

export const getDeleteAgentsIdOverridesUrl = (id: string,) => {


  

  return `/agents/${id}/overrides`
}

export const deleteAgentsIdOverrides = async (id: string, options?: RequestInit): Promise<deleteAgentsIdOverridesResponse> => {
  
  return adminBffFetch<deleteAgentsIdOverridesResponse>(getDeleteAgentsIdOverridesUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


/**
 * Proxied to agent-manager.
 * @summary Resolve effective agent config (base + overrides merged)
 */
export type getAgentsIdResolveResponse200 = {
  data: GetAgentsIdResolve200
  status: 200
}

export type getAgentsIdResolveResponse401 = {
  data: GetAgentsIdResolve401
  status: 401
}

export type getAgentsIdResolveResponse404 = {
  data: GetAgentsIdResolve404
  status: 404
}

export type getAgentsIdResolveResponse502 = {
  data: GetAgentsIdResolve502
  status: 502
}
    
export type getAgentsIdResolveResponseSuccess = (getAgentsIdResolveResponse200) & {
  headers: Headers;
};
export type getAgentsIdResolveResponseError = (getAgentsIdResolveResponse401 | getAgentsIdResolveResponse404 | getAgentsIdResolveResponse502) & {
  headers: Headers;
};

export type getAgentsIdResolveResponse = (getAgentsIdResolveResponseSuccess | getAgentsIdResolveResponseError)

export const getGetAgentsIdResolveUrl = (id: string,) => {


  

  return `/agents/${id}/resolve`
}

export const getAgentsIdResolve = async (id: string, options?: RequestInit): Promise<getAgentsIdResolveResponse> => {
  
  return adminBffFetch<getAgentsIdResolveResponse>(getGetAgentsIdResolveUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


/**
 * Proxied to agent-manager.
 * @summary List tools assigned to an agent
 */
export type getAgentsIdToolsResponse200 = {
  data: GetAgentsIdTools200
  status: 200
}

export type getAgentsIdToolsResponse401 = {
  data: GetAgentsIdTools401
  status: 401
}

export type getAgentsIdToolsResponse404 = {
  data: GetAgentsIdTools404
  status: 404
}

export type getAgentsIdToolsResponse502 = {
  data: GetAgentsIdTools502
  status: 502
}
    
export type getAgentsIdToolsResponseSuccess = (getAgentsIdToolsResponse200) & {
  headers: Headers;
};
export type getAgentsIdToolsResponseError = (getAgentsIdToolsResponse401 | getAgentsIdToolsResponse404 | getAgentsIdToolsResponse502) & {
  headers: Headers;
};

export type getAgentsIdToolsResponse = (getAgentsIdToolsResponseSuccess | getAgentsIdToolsResponseError)

export const getGetAgentsIdToolsUrl = (id: string,) => {


  

  return `/agents/${id}/tools`
}

export const getAgentsIdTools = async (id: string, options?: RequestInit): Promise<getAgentsIdToolsResponse> => {
  
  return adminBffFetch<getAgentsIdToolsResponse>(getGetAgentsIdToolsUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


